import { ModelBase } from '../../core/model/model-base';

export class HomepalDashboardMenuItemModel extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.title = dataContext.title;
      this.folder = dataContext.folder;
      this.tab = dataContext.tab;
      this.url = dataContext.url;
    }
  }

  title: string;
  url: string;
  folder: string;
  tab: string;

  toString() {
    if (!this.title) {
      return '';
    }
    return `${this.title}`;
  }
}
